import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (!this.element.dataset.checkboxTarget)
      return;

    this.$targets = document.querySelectorAll(this.element.dataset.checkboxTarget);
    this.element.addEventListener('change', (ev) => this.onChangeState(this.$targets));
    this.$targets.forEach(($el) => $el.addEventListener('change', this.toggleVisibilityTarget.bind(this)));

    this.onChangeState(this.$targets);
    if (!this.element.dataset.toggleVisibilityTarget)
      return;

    this.element.addEventListener('change', (ev) => this.toggleStates());
    this.toggleStates();
  }

  onChangeState($targets) {
    $targets.forEach(($el) => $el.checked = this.element.checked)
  }

  toggleStates() {
    this.toggleVisibilityTarget();
    this.toggleDisableTarget();
  }

  toggleVisibilityTarget() {
    let checked = [...this.$targets].reduce((a, c) => { return a ||= c.checked }, false) || this.element.checked;
    document.querySelectorAll(this.element.dataset.toggleVisibilityTarget).forEach(($el) => $el.classList.toggle('hidden', !checked));
  }

  toggleDisableTarget() {
    let checked = [...this.$targets].reduce((a, c) => { return a ||= c.checked }, false) || this.element.checked;
    document.querySelectorAll(this.element.dataset.toggleDisableTarget).forEach(($el) => $el.classList.toggle('disabled', !checked));
  }
};